import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@nomoh-monorepo/shared-data-access-environment';
import { IProfissionalDataAusente } from '@nomoh-monorepo/shared-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfissionalAusenciaService {
  private http = inject(HttpClient);
  private env = inject(EnvironmentService);

  private baseUrl(profissionalId: string): string {
    return `${this.env.getApiUrl('bardo')}/profissional/${profissionalId}/ausencia`;
  }

  async listar(profissionalId: string): Promise<IProfissionalDataAusente[]> {
    return firstValueFrom(
      this.http.get<IProfissionalDataAusente[]>(this.baseUrl(profissionalId))
    );
  }

  async criar(
    profissionalId: string,
    ausencia: Omit<IProfissionalDataAusente, 'id' | 'profissionalId'>
  ): Promise<IProfissionalDataAusente> {
    return firstValueFrom(
      this.http.post<IProfissionalDataAusente>(this.baseUrl(profissionalId), ausencia)
    );
  }

  async deletar(profissionalId: string, ausenciaId: string): Promise<void> {
    return firstValueFrom(
      this.http.delete<void>(`${this.baseUrl(profissionalId)}/${ausenciaId}`)
    );
  }
}
